import script from "./NewEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewEvent.vue?vue&type=script&setup=true&lang=ts"

import "./NewEvent.vue?vue&type=style&index=0&id=6919254c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6919254c"]])

export default __exports__